import { use } from 'react';

import { Grid } from '@mui/material';

import Dimens from '../../../themes/dimens';
import OrganisationInformationCard from '../components/cards/organisationInformationCard';
import OrganisationActionBar from '../components/organisationActionBar';
import OrganisationContext from '../providers/organisationDetailsContext';

/**
 * Todo: This whole component needs loading and error states
 */
const OrganisationDetailsContainer = () => {
	const organisationContext = use(OrganisationContext);
	const organisationId = organisationContext.organisation?.id ?? '0';

	return (
		<>
			<OrganisationActionBar organisationId={organisationId} />
			<Grid
				container
				spacing={Dimens.spacingXl}
				direction={'row'}
				sx={{
					alignItems: 'stretch',
				}}
			>
				<Grid size={{ xs: 12, md: 8, lg: 6 }}>
					<OrganisationInformationCard organisationId={organisationId} />
				</Grid>
			</Grid>
		</>
	);
};

export default OrganisationDetailsContainer;
